module.exports = __webpack_public_path__ + "img/PVQRcodeDraft.f27ca537.png";